import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button } from '@otp/ui';
import { QuestionForm } from 'src/components/wttp/questions/form';
import { Actions, AppArea, Subjects, WttpQuestionsDocument } from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';


export const CreateQuestionButton = ({
  position,
}: {
  position?: 'default' | 'fixed';
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState(false);

  return (
    <Can I={Actions.Write} a={Subjects.Questions} appArea={AppArea.Wttp}>
      <Button
        variant="contained"
        className={clsx({
          'absolute top-1 right-0': position === 'fixed',
        })}
        onClick={() => setShowModal(true)}
      >
        {t('wttp.manage-questions.create-button')}
      </Button>
      {showModal && (
        <QuestionForm
          onClose={() => setShowModal(false)}
          onFinish={() => setShowModal(false)}
          refetchQueries={[WttpQuestionsDocument]}
        />
      )}
    </Can>
  );
};
